import axios from "axios";
const request = (url, method, datas, headers) => {
  let baseURL = "http://localhost:8082";
  baseURL = "";
  const config = {
    url,
    method,
    baseURL,
    headers,
  };
  if (method == "post") config.data = datas;
  else config.params = datas;
  return new Promise((resolve) => {
    axios(config).then((res) => {
      resolve(res);
    });
  });
};

export default request;
